module.exports = __webpack_public_path__ + "img/bryantsev.b4fa9d31.png";